import { useState, useEffect, useCallback } from 'react';
import { staffApi } from '../services/staffApi';

const useApiStaff = () => {
  const [apiStaff, setApiStaff]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState(null);

  const fetchStaff = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await staffApi.getAll();
setApiStaff(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      setError(err.message);
      setApiStaff([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStaff();
  }, [fetchStaff]);

  return { apiStaff, loading, error, refetch: fetchStaff };
};

export default useApiStaff;